import { apiClient, PaginatedApiResponse } from "@/lib/apiClient";
import { SectionCategory } from "@/types/models/page";

export interface CreateSectionCategoryRequest {
  name: string;
  description?: string;
  color?: string;
  icon?: string;
}

export interface UpdateSectionCategoryRequest {
  name?: string;
  description?: string;
  color?: string;
  icon?: string;
}

export class SectionCategoryService {
  static async getSectionCategories(
    page: number = 1,
    pageSize: number = 10,
    search?: string,
  ): Promise<PaginatedApiResponse<SectionCategory[]>> {
    const params: Record<string, string> = {
      page: page.toString(),
      page_size: pageSize.toString(),
    };

    if (search) {
      params.search = search;
    }

    console.log("🌐 Calling getPaginated for section categories...");
    
    // Use getPaginated instead of get - it's designed for paginated responses
    const result = await apiClient.getPaginated<SectionCategory>(
      "/api/v1/admin/:storeId/web-builder/section-categories",
      params,
    );
    
    console.log("🎯 getPaginated result:", result);
    console.log("📦 Result data:", result.data);
    console.log("📄 Result pagination:", result.pagination);
    
    return result;
  }

  static async createSectionCategory(
    data: CreateSectionCategoryRequest,
  ): Promise<SectionCategory> {
    const response = await apiClient.post<SectionCategory>(
      "/api/v1/admin/:storeId/web-builder/section-categories",
      data,
    );
    return response.data;
  }

  static async updateSectionCategory(
    categoryId: string,
    data: UpdateSectionCategoryRequest,
  ): Promise<SectionCategory> {
    const response = await apiClient.put<SectionCategory>(
      `/api/v1/admin/:storeId/web-builder/section-categories/${categoryId}`,
      data,
    );
    return response.data;
  }

  static async deleteSectionCategory(categoryId: string): Promise<void> {
    await apiClient.delete(
      `/api/v1/admin/:storeId/web-builder/section-categories/${categoryId}`,
    );
  }

  static async getSectionCategoryById(
    categoryId: string,
  ): Promise<SectionCategory> {
    // apiClient.get already unwraps the response.data.data structure,
    // so response.data is already the SectionCategory object
    const response = await apiClient.get<SectionCategory>(
      `/api/v1/admin/:storeId/web-builder/section-categories/${categoryId}`,
    );

    console.log("🔍 getSectionCategoryById response:", response);
    console.log("🔍 getSectionCategoryById response.data:", response.data);

    return response.data;
  }

  static async getCustomSectionCategories(
    page: number = 1,
    pageSize: number = 10,
  ): Promise<PaginatedApiResponse<SectionCategory[]>> {
    const params: Record<string, string> = {
      page: page.toString(),
      page_size: pageSize.toString(),
    };

    // Use getPaginated instead of get - it's designed for paginated responses
    return await apiClient.getPaginated<SectionCategory>(
      "/api/v1/admin/:storeId/web-builder/section-categories/custom",
      params,
    );
  }
}
